import { render, staticRenderFns } from "./UiMenu.vue?vue&type=template&id=82c4e7f6"
import script from "./UiMenu.vue?vue&type=script&lang=js"
export * from "./UiMenu.vue?vue&type=script&lang=js"
import style0 from "./UiMenu.vue?vue&type=style&index=0&id=82c4e7f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports